
export const submitDisabled = (formik) => {
    // Submit is not enables if there are errors on some field that has already been touched
    return Object.keys(formik.errors).some(x => formik.touched[x])
}